// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1yhdT","footer":"Form_footer__2Wr-J"};